// Bronvermelding van de OpenStreetMap-tegels voor alle kaarten. Alleen tekst, nooit een link naar een
// externe site (Dennis 08-10: nooit externe links op onze pagina's). Leaflet zet zelf een voorvoegsel met
// een link naar leafletjs.com; dat gaat uit met `hideLeafletPrefix`.
export const OSM_ATTRIBUTION = "&copy; OpenStreetMap-bijdragers";

// Per taal van de site; onbekend of ontbrekend valt terug op de NL-tekst (nl blijft gelijk).
const OSM_ATTRIBUTION_PER_LOCALE = {
  nl: OSM_ATTRIBUTION,
  de: "&copy; OpenStreetMap-Mitwirkende",
  en: "&copy; OpenStreetMap contributors",
  fr: "&copy; les contributeurs d’OpenStreetMap",
  pl: "&copy; współtwórcy OpenStreetMap",
};

export function osmAttribution(locale) {
  return OSM_ATTRIBUTION_PER_LOCALE[locale] || OSM_ATTRIBUTION;
}

// Zet het Leaflet-voorvoegsel ("Leaflet" met link) uit op een kaart met attributionControl.
export function hideLeafletPrefix(map) {
  if (map && map.attributionControl && typeof map.attributionControl.setPrefix === "function") {
    map.attributionControl.setPrefix(false);
  }
  return map;
}
